export default {
  total_orders: {
    title: 'Pedidos',
    orders: 'Pedidos:',
    sales_volume: 'Volumen de ventas:',
    delivery_costs: 'Costes de envío:',
  },
  cash_orders: {
    title: 'Pago en efectivo / en puerta',
    orders: 'Pedidos:',
    sales_volume: 'Volumen de ventas:',
    delivery_costs: 'Costes de envío:',
  },
  online_orders: {
    title: 'Pagos en línea',
    orders: 'Pedidos:',
    sales_volume: 'Volumen de ventas:',
    delivery_costs: 'Costes de envío:',
  },
  total: 'Total',
  collected_taxes_list: {
    title: {
      online: 'Pago en línea',
      cash: 'Pago en efectivo',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Producto',
          quantity: 'Cantidad',
          total: 'Total',
        },
        labels: {
          total_refunded: 'Reembolsado',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: '% de impuesto',
          product_type: 'Tipo',
          netto: 'Neto',
          tax: 'Impuesto',
          brutto: 'Total',
        },
        product_types: {
          product: 'Productos {{percentage}}%',
          order_method_fee: 'Gastos de envío {{percentage}}%',
          customer_service_fee: 'Recargo en línea',
        },
      },
    },
  },
};
